import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { formatDate, DATE_WITH_TIME_FORMAT } from '@utils/date';
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import { Translate, I18n } from 'react-redux-i18n';
import request from 'superagent';
import _, { pick } from 'lodash';

import Select from '@ui/Select';
import Button from '@ui/Button';
import Modal from '@ui/Modal';
import { PaymentApi, userApi } from '@api/index';
import { CURRENCY } from '@constants/currency';
import DownloadCsv from '../DownloadCsv';
import { needsGroups } from '@components/utils/authHoc';
import CheckBox from '@components/utils/CheckBox';

import EditableText from '../../editor/EditableText';
import * as DateRange from '../filters/DateRangeFilter';
import * as StringIncludes from '../filters/StringIncludes';
import * as TrueFalse from '../filters/TrueFalseFilter';
import * as NumericRange from '../filters/NumericRangeFilter';
import ExpandedPayment from './expanded';
import ManualPaymentForm from './manualPaymentForm';
import {
  FAILED_STATUSES,
  REFUNDED_STATUSES,
  SUCCESS_STATUSES,
} from '@constants/payments';

export const STATUSES = [
  {
    elements: SUCCESS_STATUSES,
    text: <Translate value="userSubscribition.paymentStauses.success" />,
    className: 'bg-success',
    success: true,
  },
  {
    elements: FAILED_STATUSES,
    text: <Translate value="userSubscribition.paymentStauses.fail" />,
    className: 'bg-danger',
    fail: true,
  },
  {
    elements: REFUNDED_STATUSES,
    text: <Translate value="userSubscribition.paymentStauses.refund" />,
    className: 'bg-warning',
    fail: true,
  },
  {
    elements: ['NEW'],
    text: <Translate value="userSubscribition.paymentStauses.openForm" />,
    className: 'bg-default',
  },
];

class PaymentStats extends React.PureComponent {
  constructor(...args) {
    super(...args);

    this.onFetchData = this.onFetchData.bind(this);

    this.state = {
      checkboxes: {},
      employeesOption: [],
      payments: [],
      isAddPaymentModalVisible: false,
      totalPages: 0,
    };
  }

  STATUSES = [
    {
      elements: SUCCESS_STATUSES,
      text: I18n.t('userSubscribition.paymentStauses.success'),
      className: 'bg-success',
      success: true,
    },
    {
      elements: FAILED_STATUSES,
      text: I18n.t('userSubscribition.paymentStauses.fail'),
      className: 'bg-danger',
      fail: true,
    },
    {
      elements: REFUNDED_STATUSES,
      text: I18n.t('userSubscribition.paymentStauses.refund'),
      className: 'bg-warning',
      fail: true,
    },
    {
      elements: ['NEW'],
      text: I18n.t('userSubscribition.paymentStauses.openForm'),
      className: 'bg-default',
    },
  ];

  async componentDidMount() {
    const { users: employeesUsers } = await userApi.getEmployeesUsers();
    const {
      user: { _id: userId },
    } = this.props;
    const employeesOptions = employeesUsers
      .map(({ _id: id, email, realname }) => ({
        label:
          userId === id
            ? `${I18n.t('main.iAm')} (${realname || email})`
            : `${realname || email} ${realname ? `(${email})` : ''}`,
        value: id,
      }))
      .sort(({ value }) => (value === userId ? -1 : 1));
    this.setState({ employeesOptions });
  }

  onFetchData(options) {
    const tableOptions = pick(options, [
      'page',
      'pageSize',
      'sorted',
      'filtered',
    ]);

    ['id', 'email', 'phone'].forEach(prop => {
      const option = tableOptions.filtered.find(x => x.id === prop);
      if (option) {
        option.value = option.value.trim().toLowerCase();
      }
    });

    this.setState({ tableOptions });

    request
      .post('/payment/all')
      .send({
        ...tableOptions,
        version: 2,
      })
      .end((err, res) => {
        const { body } = res;
        this.setState({
          payments: err ? [] : body.docs,
          totalPages: err ? 0 : body.totalPages,
          totalDocs: err ? 0 : body.totalDocs,
        });
      });
  }

  getCheckboxValue = label => {
    return !!this.state.checkboxes[label];
  };

  setCheckboxValue = (label, value) => {
    this.setState({
      checkboxes: {
        ...this.state.checkboxes,
        [label]: value,
      },
    });
  };

  toggleAddPaymentModalVisible = () =>
    this.setState({
      isAddPaymentModalVisible: !this.state.isAddPaymentModalVisible,
    });

  updatePayment = async ({ id, seller, sellerIds, linkToAmoCrm }) => {
    if (!id) return;

    let updates = {};

    if (seller || seller === '') {
      updates.seller = seller;
    }

    if (sellerIds) {
      updates.sellerIds = sellerIds;
    }

    if (linkToAmoCrm || linkToAmoCrm === '') {
      updates.linkToAmoCrm = linkToAmoCrm;
    }

    await PaymentApi.updatePayment({ id, ...updates });
  };

  handleOnCreateManualPayment = async newPayment => {
    this.setState(prev => ({
      ...prev,
      payments: [newPayment, ...prev.payments],
    }));

    this.toggleAddPaymentModalVisible();
  };

  handleUpdateManualPayment = async updatedPayment => {
    this.setState(prev => {
      const prevIndex = prev.payments.findIndex(
        item => item.id === updatedPayment.id
      );
      const newPayments = _.clone(prev.payments);

      newPayments[prevIndex] = updatedPayment;

      return {
        ...prev,
        payments: newPayments,
      };
    });
  };

  render() {
    const { payments = [] } = this.state;

    const {
      user: { group },
    } = this.props;
    const isAdmin = group === 'admin';

    const editablesStyles = { height: '20px', width: '150px' };

    const columns = [
      {
        Header: (
          <span>
            {' '}
            {I18n.t('admin.paymentsStats.paymentId')} <br />{' '}
            {I18n.t('admin.paymentsStats.forCanceled')}{' '}
          </span>
        ),
        accessor: 'id',
        show: this.getCheckboxValue('show_id'),
      },
      {
        Header: I18n.t('main.user'),
        accessor: 'email',
        Filter: StringIncludes.Filter,
      },
      {
        Header: I18n.t('main.fields.labels.phone'),
        accessor: 'phone',
        Filter: StringIncludes.Filter,
      },
      {
        Header: (
          <span>
            {' '}
            <Translate dangerousHTML value="admin.paymentsStats.created" />{' '}
          </span>
        ),
        accessor: 'created',
        minWidth: 140,
        Cell: props => (
          <span> {formatDate(props.value, DATE_WITH_TIME_FORMAT)} </span>
        ),
        Filter: ({ filter, onChange }) => (
          <DateRange.Filter filter={filter} onChange={onChange} />
        ),
      },
      {
        Header: I18n.t('main.status'),
        accessor: 'status',
        Cell: props => {
          const status = this.STATUSES.find(s =>
            s.elements.includes(props.value)
          );
          return <span> {status ? status.text : props.value} </span>;
        },
        Filter: ({ filter, onChange }) => (
          <select
            onChange={event => onChange(event.target.value)}
            style={{ width: '100%' }}
            value={filter && filter.value}
          >
            <option value=""> Все </option>
            {this.STATUSES.map((s, i) => (
              <option value={i} key={`status_option_${i}`}>
                {' '}
                {s.text}{' '}
              </option>
            ))}
            <option value="other"> {I18n.t('main.other')} </option>
          </select>
        ),
      },
      {
        Header: I18n.t('admin.paymentsStats.subscription'),
        accessor: 'subscriptionID',
        Filter: StringIncludes.Filter,
        minWidth: 80,
      },
      {
        Header: I18n.t('admin.paymentsStats.sum'),
        accessor: 'price',
        Filter: StringIncludes.Filter,
        minWidth: 40,
      },
      {
        Header: I18n.t('admin.paymentsStats.currency'),
        accessor: 'currency',
        minWidth: 40,
        Filter: ({ filter, onChange }) => (
          <select
            onChange={event => onChange(event.target.value)}
            style={{ width: '100%' }}
            value={filter && filter.value}
          >
            <option value=""> Все </option>
            {Object.keys(CURRENCY).map(key => (
              <option value={CURRENCY[key]} key={CURRENCY[key]}>
                {CURRENCY[key]}
              </option>
            ))}
          </select>
        ),
      },
      {
        Header: I18n.t('admin.paymentsStats.method'),
        id: 'method',
        accessor: p => (p.promocode ? 'promocode' : p.method),
        Filter: ({ filter, onChange }) => (
          <select
            onChange={event => onChange(event.target.value)}
            style={{ width: '100%' }}
            value={filter && filter.value}
          >
            <option value="">{I18n.t('main.all')}</option>
            <option value="paypal"> PayPal </option>
            <option value="tinkoff"> Tinkoff Bank </option>
            <option value="stripe"> Stripe </option>
            <option value="yandex"> Yandex Kassa </option>
            <option value="promocode">
              {I18n.t('admin.paymentsStats.promocode')}
            </option>
            <option value="crypto"> Crypto </option>
            <option value="dolyame"> Долями </option>
            <option value="gazprom"> Gazprom </option>
            <option value="manual">
              {I18n.t('admin.paymentsStats.manual')}
            </option>
          </select>
        ),
      },
      {
        Header: 'План',
        accessor: 'plan',
        Filter: StringIncludes.Filter,
      },
      {
        Header: 'Получатель',
        accessor: 'receiver',
        filterable: false,
      },
      {
        Header: I18n.t('admin.paymentsStats.amount'),
        accessor: 'amount',
        Filter: ({ filter, onChange }) => (
          <NumericRange.Filter filter={filter} onChange={onChange} />
        ),
        minWidth: 40,
      },
      {
        Header: I18n.t('admin.paymentsStats.promocode'),
        accessor: 'promocode',
        Filter: StringIncludes.Filter,
        width: 80,
      },
      {
        Header: I18n.t('main.recurrent'),
        accessor: 'recurrent',
        Cell: TrueFalse.RenderCell,
        className: 'text-center',
        Filter: TrueFalse.Filter,
        width: 90,
      },
      {
        Header: I18n.t('admin.paymentsStats.repeated'),
        id: 'repeated',
        accessor: payment =>
          payments.some(
            p =>
              this.STATUSES[0].elements.includes(p.status) &&
              p.email === payment.email &&
              new Date(p.created) < new Date(payment.created)
          ),
        Cell: TrueFalse.RenderCell,
        className: 'text-center',
        Filter: TrueFalse.Filter,
        width: 90,
        filterable: false,
      },
      {
        Header: I18n.t('admin.paymentsStats.teacher'),
        accessor: 'teacher',
        Cell: TrueFalse.RenderCell,
        className: 'text-center',
        Filter: TrueFalse.Filter,
      },
      {
        Header: 'IP',
        accessor: 'ip',
        Filter: StringIncludes.Filter,
        width: 100,
      },
      {
        Header: 'Timezone',
        accessor: 'timezone',
        Filter: StringIncludes.Filter,
        width: 100,
      },
      {
        Header: I18n.t('admin.paymentsStats.initial'),
        accessor: 'initial',
        Filter: StringIncludes.Filter,
        show: this.getCheckboxValue('show_initial'),
      },
      {
        Header: I18n.t('admin.paymentsStats.sellerIds'),
        accessor: 'sellerIds',
        width: 210,
        Cell: props => {
          return (
            <Select
              style={{ width: '90%' }}
              defaultValue={props.value}
              mode="multiple"
              optionFilterProp="label"
              options={this.state.employeesOptions}
              key={props.original.id}
              onChange={value => {
                this.updatePayment({
                  id: props.original.id,
                  sellerIds: value,
                });
              }}
            />
          );
        },
        Filter: ({ filter, onChange }) => (
          <Select
            onChange={onChange}
            showSearch
            optionFilterProp="label"
            style={{ width: '100%' }}
            value={filter && filter.value}
            options={this.state.employeesOptions}
            allowClear
          />
        ),
      },
      {
        Header: I18n.t('admin.paymentsStats.seller'),
        accessor: 'seller',
        filterable: false,
        Cell: props => (
          <EditableText
            value={props.value}
            inputClassName="form-control"
            style={editablesStyles}
            hideIcon
            key={props.original.id}
            noLang
            finishEdit={value =>
              this.updatePayment({
                id: props.original.id,
                seller: value,
              })
            }
          />
        ),
      },
      {
        Header: I18n.t('admin.paymentsStats.hasAmoLead'),
        accessor: 'hasAmoLead',
        filterable: false,
        Cell: TrueFalse.RenderCell,
      },
      {
        Header: I18n.t('admin.paymentsStats.linkToAmoCrm'),
        accessor: 'linkToAmoCrm',
        filterable: false,
        Cell: props => (
          <EditableText
            value={props.value}
            inputClassName="form-control"
            style={editablesStyles}
            hideIcon
            key={`payment-${props.original.id}-linkToAmoCrm`}
            noLang
            finishEdit={value =>
              this.updatePayment({
                id: props.original.id,
                linkToAmoCrm: value,
              })
            }
          />
        ),
      },
    ];

    return (
      <div className="stats container-fluid">
        <Modal
          visible={this.state.isAddPaymentModalVisible}
          onCancel={this.toggleAddPaymentModalVisible}
        >
          <ManualPaymentForm onSubmit={this.handleOnCreateManualPayment} />
        </Modal>

        <h1>{I18n.t('admin.paymentsStats.title')}</h1>

        <div className="row form-group">
          <div className="col-xs-3">
            <i className="fa fa-square text-success" aria-hidden="true" />
            &nbsp;{I18n.t('admin.paymentsStats.success')}&nbsp;
            <br />
            <i className="fa fa-square text-danger" aria-hidden="true" />
            &nbsp;{I18n.t('admin.paymentsStats.fail')}&nbsp;
          </div>

          <div className="col-xs-6">
            {I18n.t('admin.paymentsStats.sort1')}
            <br />
            {I18n.t('admin.paymentsStats.sort2')}
          </div>

          <div className="col-xs-3">
            <DownloadCsv
              getData={async () => {
                const { body } = await request.post('/payment/all');
                return body.docs;
              }}
              filename="payments-progkids.csv"
            />
          </div>
        </div>

        <div className="row form-group">
          <div className="col-xs-2">
            <CheckBox
              checked={this.getCheckboxValue('show_id')}
              onChange={value => this.setCheckboxValue('show_id', value)}
            >
              {I18n.t('admin.paymentsStats.paymentId')}
            </CheckBox>
          </div>

          <div className="col-xs-2">
            <CheckBox
              checked={this.getCheckboxValue('show_initial')}
              onChange={value => this.setCheckboxValue('show_initial', value)}
            >
              {I18n.t('admin.paymentsStats.source')}
            </CheckBox>
          </div>
        </div>
        {isAdmin && (
          <div className="row form-group">
            <div className="col-xs-2">
              <Button color="green" onClick={this.toggleAddPaymentModalVisible}>
                {I18n.t('admin.paymentsStats.addPayment')}
              </Button>
            </div>
          </div>
        )}

        <ReactTable
          data={payments}
          filterable
          manual
          columns={columns}
          onFetchData={this.onFetchData}
          SubComponent={row => (
            <ExpandedPayment
              payment={row.original}
              handleUpdateManualPayment={this.handleUpdateManualPayment}
            />
          )}
          pages={this.state.totalPages}
          defaultSorted={[
            {
              id: 'created',
              desc: false,
            },
          ]}
          getTrProps={(state, rowInfo, column) => {
            const status = rowInfo && rowInfo.row.status;
            const current = this.STATUSES.find(s =>
              s.elements.includes(status)
            );

            return {
              className: current ? current.className : '',
            };
          }}
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { user } = state.auth;
  return { user };
}

export default compose(
  needsGroups('admin', 'manager'),
  connect(mapStateToProps)
)(PaymentStats);
